/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    GetTodoItemDivider,
    GetTodoItemTodo,
    GetTodoItemDividerFromJSONTyped,
    GetTodoItemDividerToJSON,
    GetTodoItemTodoFromJSONTyped,
    GetTodoItemTodoToJSON,
} from './';

/**
 * @type GetTodoItem
 * 
 * @export
 */
export type GetTodoItem = { isdivider: false } & GetTodoItemTodo | { isdivider: true } & GetTodoItemDivider;

export function GetTodoItemFromJSON(json: any): GetTodoItem {
    return GetTodoItemFromJSONTyped(json, false);
}

export function GetTodoItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTodoItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['isdivider']) {
        
            
        case true:
            return {...GetTodoItemDividerFromJSONTyped(json, true), isdivider: true};
        default:
            return {...GetTodoItemTodoFromJSONTyped(json, true), isdivider: false};
    }
}

export function GetTodoItemToJSON(value?: GetTodoItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['isdivider']) {
        
            
        case true:
            return GetTodoItemDividerToJSON(value);
        default:
            return GetTodoItemTodoToJSON(value);
    }
}

